import React, { useEffect, useRef, useState } from "react";
import { FaPencilAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import User from "../../assets/images/james-img.png";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";

export default function ClientProfileComp() {
  const { startLoader, stopLoader } = useLoader();
  const [profile, setProfile] = useState(null);
  const ProfileInput = useRef();
  const [profilePic, setProfilePic] = useState(null);

  useEffect(() => {
    const getProfile = () => {
      startLoader();
      axiosInstance
        .get("/api/client/current/")
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            localStorage.setItem('user', JSON.stringify(Data[0]));
            setProfile(Data[0]);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProfilePic = () => {
    startLoader();
    axiosInstance
      .get("/api/client/update-profile-picture/")
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          // setProfile(Data[0]);
          setProfilePic(process.env.REACT_APP_API_URL + Data.profile_picture);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const handleProfilePic = (e) => {
    startLoader();
    const formData = new FormData();
    formData.append("profile_picture", e.target.files[0]);
    axiosInstance
      .post("/api/client/update-profile-picture/", formData)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          toast.success("Profile Update Successfully");
          getProfilePic();
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  return (
    <section className="contractor-profile-sec pc-p-3">
      <div className="container align-items-center justify-content-center">
        <div className="row align-items-center">
          <div className="col-lg-12 col-12">
            <div className="profile-main-box">
              <div className="profile-sec-box">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-3">
                    <div className="client-box">
                      <img
                        src={
                          profilePic
                            ? profilePic
                            : profile?.profile_picture?.profile_picture || User
                        }
                        alt="profile"
                      />
                      <input
                        type="file"
                        ref={ProfileInput}
                        onChange={handleProfilePic}
                        hidden
                      />
                      <div className="edit-icon">
                        <Link
                          to={"#"}
                          style={{ cursor: "pointer" }}
                          onClick={() => ProfileInput.current.click()}
                        >
                          <i>
                            <FaPencilAlt />
                          </i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="primary-heading color-dark client-profile-content">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="client-profile">
                      <div className="mt-3">
                        <h5>Name:-</h5>
                        <p>{profile?.user?.name}</p>
                      </div>
                      <div className="mt-3">
                        <h5>Email Address:-</h5>
                        <p>{profile?.user?.email}</p>
                      </div>
                      {/* <div className="mt-3">
                        <h5>Country:-</h5>
                        <p>{profile?.country}</p>
                      </div> */}
                      <div className="mt-3">
                        <h5>City:-</h5>
                        <p>{profile?.city}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <div className="client-profile bd-left">
                      <div className="mt-3">
                        <h5>Description:-</h5>
                        <p>{profile?.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="text-right">
                  <Link to={CLIENT.home} className="primary-btn primary-bg">
                    Confirm Your Profile
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
